<div class="snackbar-container" [ngClass]="data.type">
    <span class="icon">
      <ng-container [ngSwitch]="data.type">
        <span *ngSwitchCase="'success'"><mat-icon>check_circle_outline</mat-icon></span>
        <span *ngSwitchCase="'error'">❌</span>
        <span *ngSwitchCase="'warning'">⚠️</span>
        <span *ngSwitchDefault>ℹ️</span>
      </ng-container>
    </span>
    <span class="message">{{ data.message }}</span>
    <span class="message">{{ data.action }}</span>
    <button mat-button (click)="snackBarRef.dismiss()">{{data.action}}</button>
</div>